import React from "react";
import { SpaceMessageAttachment } from "types/spaceTypes";
import { displayFileIcon } from "helpers";

interface SpaceMessageAttachmentsProps {
    attachments: SpaceMessageAttachment[];
    className?: string;
}

const SpaceMessageAttachments: React.FC<SpaceMessageAttachmentsProps> = ({
    attachments,
    className = "",
}) => {
    if (!attachments || attachments.length === 0) {
        return null;
    }


    return (
        <div className={`mt-2 space-y-2 ${className}`}>
            {attachments.map((attachment, index) => (
                <div
                    key={index}
                    className="rounded-lg p-3 bg-gray-50 hover:bg-gray-100 border border-transparent transition-all cursor-pointer"
                    onClick={() => {
                        // Use the URL or path for download
                        const downloadUrl = attachment.url || attachment.path;
                        if (downloadUrl) {
                            const a = document.createElement("a");
                            a.href = downloadUrl;
                            a.target = "_blank";
                            a.download = attachment.filename; // This suggests download instead of just opening
                            document.body.appendChild(a);
                            a.click();
                            document.body.removeChild(a);
                        }
                    }}
                    title="Click to download file"
                >
                    <div className="flex items-center gap-3">
                        {/* File icon */}
                        <div className="flex-shrink-0">
                            {displayFileIcon(
                                attachment.filename?.split(".").pop()?.toLowerCase() || "",
                                true,
                                "w-[25px] h-[25px]"
                            )}
                        </div>

                        {/* File info */}
                        <div className="flex-1 min-w-0">
                            <p className="text-sm font-medium text-gray-900 truncate">
                                {attachment.filename}
                            </p>
                        </div>

                    </div>
                </div>
            ))}
        </div>
    );
};

export default SpaceMessageAttachments;
